import { JonumVerificationStatus } from '#src/__generated__/globalTypes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

const AFFECTED_COUNTRY = ['FR'];

export const useApplyJonumRestriction = () => {
  const { currentUser } = useCurrentUserContext();
  const {
    currentLocation: { countryCode },
  } = useConfigContext();

  const isInAffectedCountry =
    countryCode && AFFECTED_COUNTRY.includes(countryCode.toUpperCase());
  const jonumVerification = currentUser?.jonumVerification;

  if (!jonumVerification) {
    return isInAffectedCountry;
  }

  return jonumVerification.status !== JonumVerificationStatus.EXEMPT;
};
